export default __webpack_public_path__ + "static/media/lagos.07ba1a23.png";